import React from "react";
import { CardContainer } from "../../../components/Card";
import { BarChart, LineChart } from "../../../components/Charts";

export default function InstagramTab({ data }) {
    return (
        <>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Instagram",
                            key: "ttt_instagram",
                        },
                    ]}
                    xKey="week"
                    title="TTT Instagram Followers"
                />
                <BarChart
                    data={data?.map((d) => ({
                        ...d,
                        ttt_instagram_change: d.ttt_instagram_change * 100,
                    }))}
                    series={[
                        {
                            name: "Instagram Followers",
                            key: "ttt_instagram_change",
                        },
                    ]}
                    xKey="week"
                    title="TTT Instagram Followers % Change"
                    yFormatter={(v) => `${v / 100}`}
                />
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Instagram",
                            key: "dobara_instagram",
                        },
                    ]}
                    xKey="week"
                    title="Dobara Instagram Followers"
                />
                <BarChart
                    data={data?.map((d) => ({
                        ...d,
                        dobara_instagram_change:
                            d.dobara_instagram_change * 100,
                    }))}
                    series={[
                        {
                            name: "Instagram Followers",
                            key: "dobara_instagram_change",
                        },
                    ]}
                    xKey="week"
                    title="Dobara Instagram Followers % Change"
                    yFormatter={(v) => `${v / 100}`}
                />
            </CardContainer>
        </>
    );
}
